import {HttpResponse} from '@angular/common/http';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DeviceAccessService} from '@balrog/core';
import {faPlus, faTimes, faWindowClose} from '@fortawesome/free-solid-svg-icons';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {JhiEventManager} from 'ng-jhipster';
import {Subscription} from 'rxjs';
import {AccessPermissionService} from '../../shared/auth/access-permission.service';
import {DeviceAccessDialogComponent} from '../device-access/device-access-dialog.component';
import {DeviceAccessPopupService} from '../device-access/device-access-popup.service';
import {DeviceAccess} from '../device-access/device-access.model';
import {DevicePopupService} from './device-popup.service';
import {DeviceService} from './device.service';

@Component({
    selector: 'jhi-device-users',
    templateUrl: './device-users.component.html'
})
export class DeviceUsersComponent implements OnInit, OnDestroy {
    faTimes = faTimes;
    faPlus = faPlus;
    faClose = faWindowClose;

    deviceId;
    deviceAccesses: any;
    accessPermissions: any;
    routeSub: any;
    eventSubscriber: Subscription;

    tableHeadConfig = {
        userEmail: {
            translation: 'balrogadminApp.device.users.userEmail'
        },
        deviceName: {
            translation: 'balrogadminApp.device.users.deviceName'
        },
        deviceSerialNo: {
            translation: 'balrogadminApp.device.users.deviceSerialNo'
        },
        accessLevel: {
            translation: 'balrogadminApp.device.users.accessLevel'
        }
    };

    constructor(
        public activeModal: NgbActiveModal,
        private accessPermissionService: AccessPermissionService,
        private deviceService: DeviceService,
        private deviceAccessService: DeviceAccessService,
        private deviceAccessPopupService: DeviceAccessPopupService,
        private eventManager: JhiEventManager,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.updateAccessPermissionsList();
    }

    ngOnDestroy() {
        if (this.eventSubscriber) {
            this.eventSubscriber.unsubscribe();
        }
    }

    updateList() {
        this.deviceService.getUserAccessesByDeviceId(this.deviceId).subscribe((res: HttpResponse<DeviceAccess[]>) => {
            this.deviceAccesses = res.body;
        })
    }

    updateAccessPermissionsList() {
        this.accessPermissionService.getAll().subscribe((accessPermissions) => {
            this.accessPermissions = accessPermissions;
        });
    }

    updateAccessLevel($event, deviceAccess) {
        deviceAccess.accessLevel = $event.target.value;
        this.deviceAccessService.update(deviceAccess).subscribe();
    }

    addNew() {
        const modalRef = this.deviceAccessPopupService.deviceAccessModalRef(DeviceAccessDialogComponent as Component, {
            deviceId: this.deviceId
        });
        const deviceField = modalRef.componentInstance.form.nativeElement.querySelector('#field_device');
        // Prevent user from changing the selected device.
        deviceField.setAttribute('readonly', 'readonly');
        deviceField.querySelector('input').tabIndex = -1; // prevent from change with TAB

        modalRef.result.then((result) => {
            this.updateList();
        }, (reason) => {
            if (reason !== 'cancel') {
                this.updateList();
            }
        });
    }

    deleteAccess(deviceAccess) {
        if (this.eventSubscriber) {
            this.eventSubscriber.unsubscribe();
        }

        this.eventSubscriber = this.eventManager.subscribe('deviceAccessListModification', (response) => {
            this.updateList();
        });

        this.router.navigate(['/', { outlets: { popup: 'device-access/' + deviceAccess.id + '/delete'} }])
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    navigateToUser(userId) {
        /* Workaround for not working outlets while using routerlink directive */
        this.router.navigate(['/user-management', userId]);
        setTimeout(() => {
            this.clear();
        }, 0);
    }
}

@Component({
    selector: 'jhi-device-users-popup',
    template: ''
})
export class DeviceUsersPopupComponent implements OnInit, OnDestroy {

    routeSub: any;
    routeData: any;

    constructor(
        private route: ActivatedRoute,
        private devicePopupService: DevicePopupService
    ) {}

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.routeData = this.route.data.subscribe((data) => {
                const modalRefPromise = this.devicePopupService
                    .open(DeviceUsersComponent as Component);
                modalRefPromise.then((modalRef) => {
                    modalRef.componentInstance.deviceId = Number(params.id);
                    modalRef.componentInstance.deviceAccesses = data.accessesHttp.body;
                });
            });
        });
    }

    ngOnDestroy() {
        this.routeData.unsubscribe();
    }
}
